import React from 'react';
import BaseQuestionResponse from './BaseQuestionResponse';
import { isNullOrWhitespace } from 'js/utils/string';
function LongTextQuestionResponse({ question, title, response }) {
  return (
    <BaseQuestionResponse question={question} title={title}>
      <div className="question-review-response-value">
        {!isNullOrWhitespace(response?.value) ? (
          <span
            className="question-review-response-text-prewrap line-clamp-var"
            style={{ '--line-clamp': 6 }}
          >
            {response.value.trim()}
          </span>
        ) : (
          <span className="text-no-response">No response</span>
        )}
      </div>
    </BaseQuestionResponse>
  );
}

export default LongTextQuestionResponse;
